import React, { useEffect, useState } from "react";
// store utils
import { useStore } from "outstated";
import { AppStore } from "pages/_app";
// components
import { NextSeo } from "next-seo";

export default function SubmitOffer() {
  // store
  const { user, formAddress } = useStore(AppStore);

  return (
    <>
      <NextSeo
        title={"Submit Offer - OfferMarket"}
        description={
          "Submit your offer for an off-market listing on the OfferMarket real estate marketplace."
        }
        image={`${process.env.absoluteUrl}/omlogo_placeholder.png`}
        // canonical="https://www.offermarket.us/"
        openGraph={{
          url: `${process.env.absoluteUrl}/schedule-tour`,
          title: "Schedule Tour - OfferMarket",
          description:
            "Submit your offer for an off-market listing on the OfferMarket real estate marketplace.",
          images: [
            {
              url: `${process.env.absoluteUrl}/omlogo_placeholder.png`,
              alt: "Submit your offer for an off-market listing on the OfferMarket real estate marketplace.",
            },
          ],
          site_name: "OfferMarket.us",
        }}
        twitter={{
          handle: "@OfferMarketUS",
          site: "@OfferMarketUS",
          cardType: "summary_large_image",
        }}
      />
      <div
        style={{
          height: "100vh",
          marginBottom: "10%",
        }}
      >
        <iframe
          style={{
            margin: "3% auto",
            height: "100%",
            width: "100%",
          }}
          src={`https://docs.google.com/forms/d/e/1FAIpQLSf4vyvXk7mxXDt1yCPA2qb_GYqNQAELKN39Ib7DhLjMZNX_fQ/viewform?embedded=true&entry.1916430379=${formAddress}&entry.926192109=${
            user?.attributes?.phone_number ? user?.attributes?.phone_number : ""
          }`}
          width="640"
          height="1424"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
        >
          Loading…
        </iframe>
      </div>
    </>
  );
}
